/**
 * Header.
 */

const header = (args) => {
    // setup args
    let header = args.header;
    let debounceTimeout;
    const debounceDelay = 100;
    const defaultHeaderHeight = 144;

    // validate
    if (!header) {
        // console.log('Invalid args');
        return;
    }

    function init() {
        window.header_tools.setHeaderHeight(defaultHeaderHeight);
        window.header_tools.setHeaderHeight(header.clientHeight);

        new ResizeObserver((entries) => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                const { height } = entries[entries.length - 1].contentRect;
                window.header_tools.setHeaderHeight(height);
            }, debounceDelay);
        }).observe(header);
    }

    init();

    return this;
};

header({
    header: document.querySelector('.js-site-header'),
});
